import { MorphIcon } from "morphicons/react";
import { TRAZOS } from "./trazosMorfo";

/**
 * Un icono que se transforma en otro al cambiar de estado.
 *
 * Existe para que las decisiones se tomen una sola vez y no en cada sitio
 * donde aparezca un icono con dos caras:
 *
 * - **`snappy`.** Estos morfeos son realimentación de una pulsación, no una
 *   escena: tienen que resolverse casi antes de que se levante el dedo. El
 *   muelle blando queda bien en la espera del análisis, aquí se leería lento.
 * - **`reducedMotion="user"`.** No es el valor por defecto de la librería, que
 *   morfea aunque el sistema pida menos movimiento. El resto del portal
 *   respeta esa preferencia y estos iconos no van a ser la excepción; con ella
 *   puesta, el dibujo cambia de golpe en vez de transformarse.
 * - **`aria-hidden`.** Lo pone la librería salvo que se le pase `label`, y es
 *   lo correcto: en todos los usos del portal el icono va dentro de un botón
 *   que ya tiene su propio `aria-label`. Nombrarlo otra vez lo diría dos veces.
 *
 * El morfeo solo ocurre si el componente **no se vuelve a montar**: hay que
 * cambiarle el `trazo` al mismo elemento. Si se cambia el botón entero por
 * otro, React monta un icono nuevo y lo que se ve es un salto.
 */
export function IconoMorfo({ trazo, size = 20, strokeWidth = 1.9, ...resto }) {
  return (
    <MorphIcon
      icon={TRAZOS[trazo]}
      size={size}
      strokeWidth={strokeWidth}
      color="currentColor"
      spring="snappy"
      reducedMotion="user"
      {...resto}
    />
  );
}
